var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsappTemplateAuthenticationIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161012",
    "data-name": "Group 161012",
    transform: "translate(-541.694 -440.757)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2181",
    "data-name": "Rectangle 2181",
    width: 30,
    height: 30,
    rx: 4,
    transform: "translate(541.694 440.757)",
    fill: "#c9e7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "key-alt-svgrepo-com",
    d: "M10.191,6.6H10.2m-.006,3.6A3.592,3.592,0,1,0,6.628,7.079a2.205,2.205,0,0,1,.041.473.511.511,0,0,1-.07.208,1.564,1.564,0,0,1-.255.287L3.281,11.109a1.281,1.281,0,0,0-.193.216.6.6,0,0,0-.072.173A1.282,1.282,0,0,0,3,11.787v1.041a1.489,1.489,0,0,0,.065.632.6.6,0,0,0,.262.262,1.489,1.489,0,0,0,.632.065H5a1.284,1.284,0,0,0,.289-.017.6.6,0,0,0,.173-.072,1.282,1.282,0,0,0,.216-.192l3.063-3.063a1.564,1.564,0,0,1,.287-.255.511.511,0,0,1,.208-.07,2.2,2.2,0,0,1,.473.041A3.626,3.626,0,0,0,10.191,10.191Z",
    transform: "translate(548.301 447.363)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappTemplateAuthenticationIcon);
export default __webpack_public_path__ + "static/media/whatsapp-template-authentication-icon.f5768316cf81e09d3567a93b428b336b.svg";
export { ForwardRef as ReactComponent };